import React from "react";
import { useState, useContext } from "react";
import { Link } from 'react-router-dom';

import Loader from './common/Loader';
import SearchBar from "./common/SearchBar";
import { GetTaskStatus } from "./Task.js"

import { AgGridReact } from 'ag-grid-react'; 
import { AG_GRID_LOCALE_RU } from './common/AgGrid/locale.ru';

import axios_api from "../Api";
import { API_URL, AUTH_TOKEN } from '../Context';



function Task({id, form, user, status, deadline_date, completed_date}){

  let statusDisplay = GetTaskStatus(status);

  return(
    <tr className="">
      <td><Link className="" to={`/task/` + id}> {user.username}</Link></td>
      <td>{form}</td>
      <td>{status=== "SENT" ? 
          <span className="text-primary fw-semibold">{statusDisplay}</span> 
        : 
          status=== "OUTDATED" ? 
            <span className="text-danger fw-semibold">{statusDisplay}</span> 
          : 
            <span  className="">{statusDisplay}</span>
          }
      </td>
      <td>{deadline_date}</td>
      <td>{completed_date}</td>
    </tr>
  )

}


export function TasksCycleList({year, cycle, cachedTasks, onTasksLoaded}) {
  
  const [loading, setLoading] = useState(!cachedTasks);
  const [tasks, setTasks] = useState(cachedTasks || []);
  
  const [searchText, setSearchText] = useState('');

  const api_url = useContext(API_URL);  
  const token = useContext(AUTH_TOKEN);


  const LinkCellRenderer = function(params) {
  
    const url = 'task/' + params.data.id || `#`; // Fallback URL

    return (
      <a href={url} target="_blank" rel="noopener noreferrer">
        {params.data.lab.username}
      </a>
    );
  }

  // Функция для парсинга даты в формате DD-MM-YYYY
  // Возможно лучше использовать другую стандартную функцию? Или с бекенда отдавать объект Time в другом формате
  const parseDate = (dateString) => {
    if (!dateString) return null;
    const parts = dateString.split('-');
    if (parts.length !== 3) return null;
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1; // месяцы в JS начинаются с 0
    const year = parseInt(parts[2], 10);
    const date = new Date(year, month, day);
    return isNaN(date.getTime()) ? null : date;
  }

  const [colDefs, setColDefs] = useState([
      { field: "lab", headerName: "Лаборатория", "width": 160,
        cellRenderer: LinkCellRenderer,
        valueGetter: (params) => params.data?.lab?.username || '',
        filterValueGetter: (params) => params.data?.lab?.username || ''
      },
      { field: "form", headerName: "Форма", flex: 2},
      { field: "status", "headerName": "Статус", "width": 210,
        cellClass: params => {
          if (params.value === 'Отправлено') {
            return 'text-primary-emphasis fw-bold'
          }
          if (params.value === 'Отдано Эксперту') {
            return 'text-info-emphasis fw-bold'
          }          
          return null;
        }
      },
      { field: "deadline_date", "headerName": "Дата предоставления", "width": 200,
        valueGetter: (params) => {
          return parseDate(params.data?.deadline_date);
        },
        cellRenderer: (params) => {
          return params.data?.deadline_date || '';
        },
        comparator: (valueA, valueB) => {
          if (valueA === null && valueB === null) return 0;
          if (valueA === null) return 1;
          if (valueB === null) return -1;
          return valueA.getTime() - valueB.getTime();
        }
      },
      { field: "completed_date", "headerName": "Дата выполнения", "width": 170,
        valueGetter: (params) => {
          return parseDate(params.data?.completed_date);
        },
        cellRenderer: (params) => {
          return params.data?.completed_date || '';
        },
        comparator: (valueA, valueB) => {
          if (valueA === null && valueB === null) return 0;
          if (valueA === null) return 1;
          if (valueB === null) return -1;
          return valueA.getTime() - valueB.getTime();
        }
      }  
  ]);


  React.useEffect(() => {
    // Если данные уже есть в кэше, не делаем запрос
    if (cachedTasks) {
      setTasks(cachedTasks);
      setLoading(false);
      return;
    }

    // Если данных нет в кэше, делаем запрос
    setLoading(true);
    let formsYears = axios_api.get(api_url + '/tasks/', {
      headers: {"Authorization": token},
      params: {"year": year, "cycle": cycle}
    });

    formsYears.then(
      (result) => {
        let apiReturnedTasks = result.data;

        for(let i in apiReturnedTasks) {
          apiReturnedTasks[i].status = GetTaskStatus(apiReturnedTasks[i].status);
        }

        setTasks(apiReturnedTasks);
        setLoading(false);
        // Сохраняем данные в кэш через callback
        if (onTasksLoaded) {
          onTasksLoaded(year, cycle, apiReturnedTasks);
        }
      },
      (error) => {
        console.log(error);
        setTasks([]);
        setLoading(false);
      }
    );

  }, [year, cycle, cachedTasks]);

  /*
  let rows = [];
  for(let i in tasks) {
    console.log(tasks[i])
    if (tasks[i].lab.username.toLowerCase().indexOf(searchText.toLowerCase()) === -1) {
      //pass
    } else {

      rows.push(
        <Task
          key={tasks[i].id}
          id={tasks[i].id}  
          form={tasks[i].form}
          user={tasks[i].lab}
          status={tasks[i].status}
          deadline_date={tasks[i].deadline_date}
          completed_date={tasks[i].completed_date}
        />
      );
    }
  }
 */
 
  console.log(tasks)

  return ( loading ? 
    (
      <Loader/>
    ) : (  
      <div className="mx-5 ps-5">
        <div className="row mt-3 mb-5" style={{ width: "100%" }}>
          <AgGridReact
            rowData={tasks}
            columnDefs={colDefs}
            domLayout='autoHeight'
            defaultColDef={{
              sortable: true,
              filter: true,
              resizable: true
            }}
            localeText={AG_GRID_LOCALE_RU}
          />
        </div>
      </div>
    )  
  );
}


export default function TaskYearsCyclesStructure({}) {

  const [tasksStructure, setTasksStructure] = useState([]);
  // Кэш для хранения данных заданий по ключу "year-cycle"
  const [tasksCache, setTasksCache] = useState({});
  
  const api_url = useContext(API_URL);  
  const token = useContext(AUTH_TOKEN);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState('');

  // Функция для сохранения данных заданий в кэш
  const handleTasksLoaded = (year, cycle, tasks) => {
    const cacheKey = `${year}-${cycle}`;
    setTasksCache(prevCache => ({
      ...prevCache,
      [cacheKey]: tasks
    }));
  };

  // Функция для получения данных заданий из кэша
  const getCachedTasks = (year, cycle) => {
    const cacheKey = `${year}-${cycle}`;
    return tasksCache[cacheKey] || null;
  };

  React.useEffect(() => {

    let structure = axios_api.get(api_url + '/tasks_years_cycles/', {
      headers: {"Authorization": token},
    });

    structure.then(
      (result) => {
        let apiReturnedTasksStructure = result.data;
        console.log(result);
        setTasksStructure(apiReturnedTasksStructure);
      },
      (error) => {
        console.log(error);
        setTasksStructure([]);
      }
    );

  }, []);

  function openYearFolder (year) {
    let newTaskStructure = structuredClone(tasksStructure);
    newTaskStructure[year].selected = true;
    setTasksStructure(newTaskStructure);
  }

  function closeYearFolder (year) {
    let newTaskStructure = structuredClone(tasksStructure);
    newTaskStructure[year].selected = false;
    setTasksStructure(newTaskStructure);
  }

  function openCycleSubfolder (year, cycle) {
    let newTaskStructure = structuredClone(tasksStructure);
    newTaskStructure[year].year_cycles[cycle].selected = true;
    setTasksStructure(newTaskStructure);
  }

  function closeCycleSubfolder (year, cycle) {
    let newTaskStructure = structuredClone(tasksStructure);
    newTaskStructure[year].year_cycles[cycle].selected = false;
    setTasksStructure(newTaskStructure);
  }


  let tasksYearsRows = [];
  for (let year in tasksStructure) {

    let yearCycles = [];
    for (let cycle in tasksStructure[year].year_cycles) {
      
      if (tasksStructure[year].year_cycles[cycle].selected === true) {
        yearCycles.push(
          <React.Fragment 
            key={cycle}
          >
            <div
              className="row mx-5 mt-2 p-2 pt-2 rounded year-hover"
              onClick={() => closeCycleSubfolder(year, cycle)}
            >
              <h4>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-folder-minus me-3" viewBox="0 0 16 16">
                  <path d="m.5 3 .04.87a2 2 0 0 0-.342 1.311l.637 7A2 2 0 0 0 2.826 14H9v-1H2.826a1 1 0 0 1-.995-.91l-.637-7A1 1 0 0 1 2.19 4h11.62a1 1 0 0 1 .996 1.09L14.54 8h1.005l.256-2.819A2 2 0 0 0 13.81 3H9.828a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 6.172 1H2.5a2 2 0 0 0-2 2m5.672-1a1 1 0 0 1 .707.293L7.586 3H2.19q-.362.002-.683.12L1.5 2.98a1 1 0 0 1 1-.98z"/>
                  <path d="M11 11.5a.5.5 0 0 1 .5-.5h4a.5.5 0 1 1 0 1h-4a.5.5 0 0 1-.5-.5"/>
                </svg>
                цикл {tasksStructure[year].year_cycles[cycle].cycle}
              </h4>
            </div>
            <TasksCycleList
              year={tasksStructure[year].year}
              cycle={tasksStructure[year].year_cycles[cycle].cycle}
              cachedTasks={getCachedTasks(tasksStructure[year].year, tasksStructure[year].year_cycles[cycle].cycle)}
              onTasksLoaded={handleTasksLoaded}
            />
          </React.Fragment>
        )    
      } else {
        yearCycles.push(
          <React.Fragment 
              key={cycle}
            >
            <div
              className="row mx-5 mt-2 p-2 pt-2 rounded year-hover"
              onClick={() => openCycleSubfolder(year, cycle)}
            >
              <h4>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-folder-plus me-3" viewBox="0 0 16 16">
                <path d="m.5 3 .04.87a2 2 0 0 0-.342 1.311l.637 7A2 2 0 0 0 2.826 14H9v-1H2.826a1 1 0 0 1-.995-.91l-.637-7A1 1 0 0 1 2.19 4h11.62a1 1 0 0 1 .996 1.09L14.54 8h1.005l.256-2.819A2 2 0 0 0 13.81 3H9.828a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 6.172 1H2.5a2 2 0 0 0-2 2m5.672-1a1 1 0 0 1 .707.293L7.586 3H2.19q-.362.002-.683.12L1.5 2.98a1 1 0 0 1 1-.98z"/>
                <path d="M13.5 9a.5.5 0 0 1 .5.5V11h1.5a.5.5 0 1 1 0 1H14v1.5a.5.5 0 1 1-1 0V12h-1.5a.5.5 0 0 1 0-1H13V9.5a.5.5 0 0 1 .5-.5"/>
              </svg>
                цикл {tasksStructure[year].year_cycles[cycle].cycle}
              </h4>
            </div>
          </React.Fragment>    
        )    
      }
    }

    if (tasksStructure[year].selected === true) {
      tasksYearsRows.push(
        // Without the `key`, React will fire a key warning. 
        // <React.Fragment></React.Fragment> - из full syntax for <></> shortcut
        <React.Fragment 
          key={year}
        >
          <div
            className="row mx-3 mt-3 p-2 pt-3 rounded year-hover"
            onClick={() => closeYearFolder(year)}
          >
            <h3>
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" className="bi bi-folder-minus me-3" viewBox="0 0 16 16">
                <path d="m.5 3 .04.87a2 2 0 0 0-.342 1.311l.637 7A2 2 0 0 0 2.826 14H9v-1H2.826a1 1 0 0 1-.995-.91l-.637-7A1 1 0 0 1 2.19 4h11.62a1 1 0 0 1 .996 1.09L14.54 8h1.005l.256-2.819A2 2 0 0 0 13.81 3H9.828a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 6.172 1H2.5a2 2 0 0 0-2 2m5.672-1a1 1 0 0 1 .707.293L7.586 3H2.19q-.362.002-.683.12L1.5 2.98a1 1 0 0 1 1-.98z"/>
                <path d="M11 11.5a.5.5 0 0 1 .5-.5h4a.5.5 0 1 1 0 1h-4a.5.5 0 0 1-.5-.5"/>
              </svg>
              {tasksStructure[year].year}
            </h3>
          </div>
          {yearCycles}
        </React.Fragment>  
      )
    } else {
      tasksYearsRows.push(
        <div
          key={tasksStructure[year].year}  
          className="row mx-3 mt-3 p-2 pt-3 rounded year-hover"
          onClick={() => openYearFolder(year)}
        >
          <h3>
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" className="bi bi-folder-plus me-3" viewBox="0 0 16 16">
              <path d="m.5 3 .04.87a2 2 0 0 0-.342 1.311l.637 7A2 2 0 0 0 2.826 14H9v-1H2.826a1 1 0 0 1-.995-.91l-.637-7A1 1 0 0 1 2.19 4h11.62a1 1 0 0 1 .996 1.09L14.54 8h1.005l.256-2.819A2 2 0 0 0 13.81 3H9.828a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 6.172 1H2.5a2 2 0 0 0-2 2m5.672-1a1 1 0 0 1 .707.293L7.586 3H2.19q-.362.002-.683.12L1.5 2.98a1 1 0 0 1 1-.98z"/>
              <path d="M13.5 9a.5.5 0 0 1 .5.5V11h1.5a.5.5 0 1 1 0 1H14v1.5a.5.5 0 1 1-1 0V12h-1.5a.5.5 0 0 1 0-1H13V9.5a.5.5 0 0 1 .5-.5"/>
            </svg>
            {tasksStructure[year].year}
          </h3>
        </div>
      )
    }  
  }

  return(
    <>
      <div className="row">
        <h3 className="m-3">Задания</h3>
      </div>
      <Link className="lk-button m-3" to={`/load_tasks`}>Загрузить задания</Link>
      <Link className="lk-button m-3" to={`/task_create`}>Создать задание</Link>
      <Link className="lk-button m-3" to={`/export_multiple_tasks`}>Массовая выгрузка</Link>
      {tasksYearsRows} 
    </>
  );
}
